import {useEffect, useState} from 'react';
import {KeyConstant} from '../../utils/constants/keys.constants';
import './style.scss';

export default function CustomFilterSelect({
                                               optionsList,
                                               placeholder,
                                               setKidsGroup,
                                               valueEdit,
                                               edit,
                                               addInfo,
                                               keyName
                                           }) {
    // STATES
    const [filterSelectOpen, setFilterSelectOpen] = useState(false);
    const [selectName, setSelectName] = useState(placeholder);

    // METHODS
    function handleOpen() {
        setFilterSelectOpen(!filterSelectOpen);
    }

    function chooseOption(e, name) {
        setSelectName(name);
        if (setKidsGroup) {
            if (name !== KeyConstant.SCHOOL_TYPE) {
                setKidsGroup(false);
            } else setKidsGroup(true);
        }
        if (addInfo) {
            addInfo(e.target.name, e.target.id, name);
        }
        handleOpen();
    }

    useEffect(() => {
        if (valueEdit) {
            setSelectName(valueEdit);
        }
        if (edit) {
            setSelectName(edit);
        }
    }, []);

    return (
        <div className='custom-filters-container'>
            <button className='first-option' type='button' onClick={handleOpen}>
                <p>{selectName}</p>

                {filterSelectOpen ? (
                    <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='14.922'
                        height='8.875'
                        viewBox='0 0 14.922 8.875'>
                        <g
                            id='Arrow-Right'
                            transform='translate(-8.586 14.461) rotate(-90)'>
                            <path
                                id='Trazado_585'
                                data-name='Trazado 585'
                                d='M0,0,6.047,6.047,12.094,0'
                                transform='translate(7 22.094) rotate(-90)'
                                fill='none'
                                stroke='#909090'
                                strokeLinecap='round'
                                strokeWidth='2'
                            />
                        </g>
                    </svg>
                ) : (
                    <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='14.922'
                        height='8.875'
                        viewBox='0 0 14.922 8.875'>
                        <g id='Arrow-Right' transform='translate(23.508 -5.586) rotate(90)'>
                            <path
                                id='Trazado_585'
                                className='path2'
                                data-name='Trazado 585'
                                d='M0,0,6.047,6.047,12.094,0'
                                transform='translate(7 22.094) rotate(-90)'
                                fill='none'
                                stroke='#909090'
                                strokeLinecap='round'
                                strokeWidth='2'
                            />
                        </g>
                    </svg>
                )}
            </button>
            {filterSelectOpen ? (
                <div className='options-container'>
                    {optionsList && optionsList.length> 0 && optionsList?.map((optionItem, i) => (
                        <button
                            name={keyName}
                            className='option'
                            key={i}
                            id={optionItem.id}
                            value={optionItem.name}
                            onClick={e => {
                                chooseOption(e, optionItem.name);
                            }}
                            type='button'>
                            {optionItem.name}
                        </button>
                    ))}
                </div>
            ) : null}
        </div>
    );
}
